<div class="reportviewer">
    <button class="print-button" (click)="print()"><span class="print-icon"></span></button>
</div>
<div class="content-block">
    <div *ngIf="isLoading" class="loader-overlay">
        <div class="spinner"></div>
    </div>
    <dx-report-viewer [reportUrl]="reportUrl" height="1200px" cssClass='myViewer'>
        <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrl"></dxrv-request-options>
        <dxrv-callbacks (ParametersInitialized)="OnParametersInitialized($event)" (BeforeRender)="onBeforeRender()"
            (DocumentReady)="onDocumentReady()"></dxrv-callbacks>
    </dx-report-viewer>
</div>